export const IMAGESFOLDER = "images/villages/";

export const ALICANTE_PHOTOS_NUMBER = 14;

export const APP_TITLE = "Wandering Alicante";

export const APP_E_SLOGAN = "A photographic journey through Alicante and its villages"
export const APP_S_SLOGAN = "Un viaje fotográfico a través de Alicante y sus pueblos"

export const E_INTRODUCTION_TEXT = ["My name is Luis Massó. I work as a Software Developer. Two of my hobbies are hikking and photography. It's normal that I have felt the call to create this web. I propose you a jurney around Alicante and its villages and small towns. ",
"Here, in an small number of photographies that you can take a quick look of this beauty, amazing, ancient and at the same time modern villages.",
"All the pictures of each village was taken in a session, in an afternoon. Arrive, walk and click on my camera... and no Photoshop",
"Maybe you will decide to visit some on these villages. Enjoy!!"]

export const S_INTRODUCTION_TEXT = ["Mi nombre es Luis Massó. Trabajo como programador. Dos de mis hobbies son el senderismo y la fotografía. Siento la llamada para crear esta web. Les propongo un viaje alrededor de Alicante y sus pueblos. ",
"Aquí, con un pequeño número de fotografías puede echar un rápido vistazo a la maravillosa belleza de estos antiguos y a la vez modernos pueblos.",
"Las fotografías fueron hechas en una sesión, en una tarde. Llegar, caminar y click con la cámara y... sin Photoshop.",
"Quizá decida usted visitar alguno de estos pueblos !!!Disfrute!!!"]

export const ALT_IMAGES = [
  "",
  "Image of Santa Barbara Castle.", 
  "Image of La Albufera from the castle.",
  "Image of the dock bay from the castle.",
  "Image of Avenue of Denia from the castle.",
  "Image of the sea port from the castle.",
  "Image of the sea port from the castle.",
  "Image of Alicante with Gran Sol Hotel in first term.",
  "Image of Alicante with Gran Sol Hotel in first term.",
  "Night image of Alicante",
  "Night image of Alicante",
  "Santa Barbara Castle by night",
  "Night image of Alicante",
  "Night image of Alicante Sea Port",
  "Night image of Alfonso el Sabio street"
]

export const VILLAGES = [
  {
    id: 0,
    name: "Home"
  },
  { 
    id: 1,
    name: "Agost",
    iurl: "https://en.wikipedia.org/wiki/Agost",
    surl: "https://es.wikipedia.org/wiki/Agost",
    
    stext: [" es un municipio y localidad española de la provincia de Alicante, en la Comunidad Valenciana. Ubicado a unos 18 km al oeste de la ciudad de Alicante, en la comarca del Campo de Alicante, contaba con 4794 habitantes en 2020 (INE).",
    "Agost se encuentra en los lindes de la llanura litoral que circunda la ciudad de Alicante, donde el terreno se eleva (sierra del Ventós, Maigmó). Sus límites son: al norte, Castalla; al este, Tibi y Alicante; al oeste, Monforte del Cid y Petrel; y al sur, Alicante.", 
    "El núcleo más antiguo se distribuye por la parte más alta del cerro que ocupa el pueblo, y parece ser de época íbera, como lo demuestra el hallazgo entre otras piezas, de la Esfinge de Agost. También hay yacimientos de época romana. "],
    
    itext: [" is a Spanish municipality and town in the province of Alicante, in the Valencian Community. Located about 18 km to the west of the city of Alicante, in the region of the Campo de Alicante, he had 4794 inhabitants in 2020 (INE).",
    "Agost is located on the edge of the coastal plain that surrounds the city of Alicante, where the terrain rises (Sierra del Ventós, Maigmó). Its limits are: to the north, Castalla; to the east, Tibi and Alicante; to the west, Monforte del Cid and Petrel; and to the south, Alicante.",
    "The oldest nucleus is distributed by the highest part of the hill that the town occupies, and it seems to be from the Iberian period, as evidenced by the finding, among other pieces, of the Sphinx of Agost. There are also sites from Roman times. "],
    
    h: 72,
    v: 6
  },

  { 
    id: 2,
    name: "Aspe",
    iurl: "https://en.wikipedia.org/wiki/Aspe",
    surl: "https://es.wikipedia.org/wiki/Aspe",
    
    stext: [" es un municipio del interior de la provincia de Alicante, Comunidad Valenciana, España. Tiene una población de 20.425 habitantes, según las cifras oficiales del INE de 2017."],
    
    itext: [" is a village within of province of Alicante, Valencian Community, Spain. It has a population of 20,425 inhabitants, according to the official data of INE of 2017."],
    
    h: 24,
    v: 0
  },

  {
    id: 3,
    name: "Guardamar del Segura", 
    iurl: "https://en.wikipedia.org/wiki/Guardamar_del_Segura",
    surl: "https://es.wikipedia.org/wiki/Guardamar_del_Segura",
    
    stext: [" (en español antiguamente hasta 1916 Guardamar)​ es una ciudad y municipio costero de la provincia de Alicante, en la Comunidad Valenciana, España. Situado en la costa sureste de la provincia, forma parte de la comarca de la Vega Baja del Segura. Cuenta con 15 849 habitantes (INE 2020).",
    "En su término municipal se encuentra la desembocadura del río Segura; la localidad es también conocida por su pinar, plantado a principios del siglo XX para frenar el avance de las dunas móviles litorales, que hasta ese momento invadían los campos de cultivo aledaños. "],
    
    itext: [" (Valencian pronunciation: [ˌɡwaɾðaˈmaɾ ðel seˈɣuɾa]) or briefly Guardamar is a municipality of the province of Alicante located at the mouth of the river Segura in southern Valencia (autonomous community), Spain. It is a Mediterranean resort, with a large pine forest abutting an 11-km-long white sand beach.",
    "Historically an area of fishermen and farmers, Guardamar del Segura is the southernmost point where Valencian is spoken. A Phoenician colony, called Herna by Roman geographer Avienius in his book Ora Maritima was the first settlement near the mouth of Segura river,[2] In Spanish, \"guardar\" means \"safekeeping\" and \"mar\" means \"sea\", and this is another possible basis for its current name.",
    "Guardamar is the southernmost Catalan-speaking town and in 1991 41.8% of the town's residents could speak it.[3] Guardamar hosts local festivals like Moros i Cristians, L'Encantà, and Fogueres de Sant Joan, which commemorate its history." ],
    
    h: 96,
    v: 0
  },

  {
    id: 4,
    name: "Hondón de las Nieves", 
    iurl: "https://en.wikipedia.org/wiki/El_Fondó_de_les_Neus",
    surl: "https://es.wikipedia.org/wiki/Novelda",
    
    stext: [" (en valenciano cooficialmente, el Fondó de les Neus) es una población de la Comunidad Valenciana, España. Situada en el suroeste de la provincia de Alicante, en la comarca del Vinalopó Medio. Cuenta con 2544 habitantes (INE 2019). ",
    "El término –68,9 km²– se ubica en un pequeño valle protegido por la sierra de Crevillente y la sierra de Algayat , poblado de pinos, almendros, olivos y viñas. Ofrece parajes muy agradables, como por ejemplo el llamado de La Cuesta o el de La Cruz, habilitados para el esparcimiento. Si decidimos reconocer el término caminando, podemos escoger la ruta del Alto Pelao, donde podemos observar numerosas especies vegetales: pino, enebro, tomillo, romero... La fauna local incluye: jabalíes, zorros, perdices, liebres, conejos, lagartos, búhos reales, etc."],
    
    itext: [" (Valencian pronunciation: [fonˈdo ðe lez ˈnɛws]; Spanish: Hondón de las Nieves [onˈdon de laz ˈnjeβes]) is a municipality in the comarca of Vinalopó Mitjà in the Comunidad Valenciana, Spain.",
    "It is a small village, inland, west of the Alicante province. Its nearest city is Elche to the south east or Crevillente. The name literally means \"Gorge of the Snow\", a reference to the village's patron \"The Virgin of the Snow\". This effigy and the church is at the heart of village life. "],
    
    h: 72,
    v: 0
  },

  {
    id: 5,
    name: "Ibi", 
    iurl: "https://en.wikipedia.org/wiki/Ibi",
    surl: "https://en.wikipedia.org/wiki/Ibi,_Spain",
    
    stext: [" es un municipio del interior de la provincia de Alicante, en la Comunidad Valenciana, España. Situada en la comarca de la Hoya de Alcoy, es la población más grande de la subcomarca geográfica de la Hoya de Castalla. Cuenta con 23 564 habitantes​ (INE, 2020)."],
    
    itext: [" (Valencian and Spanish: [ˈiβi]) is a town located in the comarca of Alcoià, in the province of Alicante, Spain. As of 2009, Ibi has a total population of c. 24,000 inhabitants. The town, which is located 37 km from the city of Alicante, is surrounded by mountains and gorges.",
    "The economy of Ibi is chiefly based on the toy industry, the most important of this kind in Spain. As a result, many other related industries have also emerged in the last years: plastic, metal, machinery and others. There are some factories making construction materials, ice creams and tiger nut milk, also.",
    "Some of the most important monuments in Ibi are the Catholic Church of the Transfiguration and the monument to the Three Wise Men, possibly the only one in the world. "],
    
    h: 48,
    v: 0
  },

  {
    id: 6,
    name: "Novelda", 
    iurl: "https://en.wikipedia.org/wiki/Novelda",
    surl: "https://es.wikipedia.org/wiki/Novelda",
    
    stext: [" es un municipio situado en el interior de la provincia de Alicante, en la comarca del Medio Vinalopó. Conocido por su producción de uva y el comercio de especias y mármol, la localidad contaba con 25.651 habitantes en 2019 (INE)."],
    
    itext: [" is a village located inside of the province of Alicante, in the region of Medio Vinalopó. Known for its grape production and the spices and marble trade. The town had 25,651 inhabitants in 2019 (INE)."],
    
    h: 30,
    v: 6
  },

  {
    id: 7,
    name: "Monforte del Cid",
    iurl: "https://en.wikipedia.org/wiki/Monforte_del_Cid",
    surl: "https://es.wikipedia.org/wiki/Monforte_del_Cid",
    
    stext: [" es un municipio de la Comunidad Valenciana, España. Situado en el interior de la provincia de Alicante, en la comarca del Medio Vinalopó. Cuenta con 8165 habitantes, una superficie de 79.2 km² y una densidad poblacional del 102.65 hab./km² (INE 2019)",
    "Nompot, nombre medieval de Monforte del Cid, cuenta con la distinción monárquica del orlado Toisón de Oro, siendo una concesión del rey Felipe V en el año 1706, junto con el título de «Villa Real, Leal y Fiel», por el apoyo a este en la Guerra de Sucesión Española."],
    
    itext: [" is a village in the Valencian Community, Spain. Located inside of the province of Alicante, in the region of Medio Vinalopó. It has 8165 inhabitants, a surface area of 79.2 km² and a population density of 102.65 inhabitants / km² (INE 2019)",
    "Nompot, medieval name of Monforte del Cid, has the monarchical distinction of the Orlado Toisón de Oro, being a concession of King Felipe V in 1706, together with the title of 'Villa Real, Leal y Fiel', for supporting this in the War of the Spanish Succession."],
    
    h: 42,
    v: 0
  },

  {
    id: 8,
    name: "Monóvar",
    iurl: "https://es.wikipedia.org/wiki/Monóvar",
    surl: "https://es.wikipedia.org/wiki/Monóvar",

    stext: [" (en valenciano y cooficialmente, Monòver) es una ciudad situada al sureste de España, en la Comunidad Valenciana, provincia de Alicante, comarca del Medio Vinalopó (en valenciano, Vinalopó Mitjà o Valls del Vinalopó). Cuenta con 12.800 habitantes (INE 2016), " +
    "de los cuales 12.000 viven en el casco urbano de Monóvar, y los 800 restantes, viven diseminados por las distintas pedanías y aldeas, además de los campos que comprende el término municipal. Es una de las ciudades más importantes de la Comunidad Valenciana por su industria."],
    itext: [" (in Valencian and co-officially, Monòver) is a city located in the southeast of Spain, in the Valencian Community, province of Alicante, region of Medio Vinalopó (in Valencian, Vinalopó Mitjà or Valls del Vinalopó) . It has 12,800 inhabitants (INE 2016), " +
    "of which 12,000 live in the urban area of Monóvar, and the remaining 800 live scattered throughout the different districts and villages, in addition to the fields that comprise the municipality. It is one of the most important cities in the Valencian Community for its industry."],
    
    h: 24,
    v: 16
  },

  {
    id: 9,
    name: "Muchamiel",
    iurl: "hhttps://en.wikipedia.org/wiki/Mutxamel",
    surl: "https://es.wikipedia.org/wiki/Muchamiel",

    stext: ["​ (en valenciano y oficialmente, Mutxamel) es un municipio de la provincia de Alicante, en la Comunidad Valenciana, España. Está situado en la parte norte del área metropolitana de Alicante y en la comarca del Campo de Alicante. Cuenta con 25 679 habitantes (INE 2021). Su territorio abarca 47,7 km². ", 
    "Integrado en la comarca de Campo de Alicante, se sitúa a 10 kilómetros del centro de la capital provincial. El término municipal está atravesado por la Autopista del Mediterráneo (AP-7) y por la autovía de circunvalación de Alicante (A-70), además de por las carreteras autonómicas CV-800 (antigua N-340), que permite la comunicación con Jijona, CV-773, que conecta con Busot, y la CV-821, que se dirige a San Vicente del Raspeig y a San Juan de Alicante.",
    "El relieve del municipio es predominantemente llano, por situarse en pleno Campo de Alicante, sin embargo, al oeste se alzan pequeñas sierras (Serra del Boter, Serra Pelada). El río Monnegre o río Seco cruza el norte el territorio camino de la costa. La altitud oscila entre los 468 metros al oeste (pico Sabinar) y los 40 metros a orillas del río Monnegre. El pueblo se alza a 63 metros sobre el nivel del mar​. "],
    itext: [" (Valencian pronunciation: [mutʃaˈmɛl])[2] or Muchamiel (in Spanish) is a municipality in the comarca of Alacantí, Alicante, Valencian Community, Spain. "],
    
    h: 0,
    v: 0
  },

  {
    id: 10,
    name: "Pinoso",
    iurl: "https://en.wikipedia.org/wiki/Pinoso",
    surl: "https://es.wikipedia.org/wiki/Pinoso",

    stext: ["​ es un municipio de la Comunidad Valenciana (España) situado en la costa de la provincia de Alicante, en la comarca del Bajo Vinalopó. Contaba con 31.745 habitantes en 2018 (INE).4​ Los principales atractivos de Santa Pola son sus restos históricos, su puerto, " +
    "El término municipal de Pinoso tiene una extensión de 126,9 km².",
    "El relieve está constituido por grandes glacis que bajan de las sierras vecinas y amplias vaguadas, a veces sin suficiente drenaje, lo que da lugar a los típicos hondos, en los que de manera ocasional puede llegar a encharcarse el agua."],
    itext: [", officially Pinoso / El Pinós (in Spanish and Valencian) is a traditional town which sits located in the mountainous countryside of the Alicante/Murcia border (at some 56 km from Alacant). This traditional town is renowned for the production of fine wines, rock salt and marble. " + 
    "Pinoso has a population of 7,300 and a municipal area of 126 km2. Recently it has experienced a growth in tourism. "],
    
    h: 42,
    v: 6
  },

  {
    id: 11,
    name: "Santa Pola",
    iurl: "https://en.wikipedia.org/wiki/Santa_Pola",
    surl: "https://es.wikipedia.org/wiki/Santa_Pola",

    stext: ["​ (en valenciano El Pinós y oficialmente Pinoso/El Pinós)[2]​ es un municipio de la Comunidad Valenciana, España. Está situado en el oeste de la provincia de Alicante, en la comarca del Medio Vinalopó, lindando con la Región de Murcia. Cuenta con 8142 habitantes (INE 2021).[3]​Se trata de un municipio en el que el Valenciano cuenta con el predominio lingüístico reconocido legalmente. " +
    "sus salinas y sus playas dotadas de bandera azul, símbolo de calidad ambiental otorgado por la Fundación Europea de Educación Ambiental."],
    itext: [" is a village of the Valencian Community (Spain) located on the coast of the province of Alicante, in the Bajo Vinalopó region. It had 31.745 inhabitants in 2018 (INE) .4 The main attractions of Santa Pola are its historical remains, its port, its salt flats " + 
    "and its beaches endowed with the blue flag, a symbol of environmental quality awarded by the European Foundation for Environmental Education."],
    
    h: 60,
    v: 0
  },
  
  {
    id: 12,
    name: "Villajoyosa",
    iurl: "https://en.wikipedia.org/wiki/Villajoyosa",
    surl: "https://es.wikipedia.org/wiki/Villajoyosa",

    stext: ["Villajoiosa (en valenciano y cooficialmente La Vila Joiosa),​ es un municipio de la Comunidad Valenciana, España. Perteneciente a la provincia de Alicante y situado en la Costa Blanca, en la comarca de la Marina Baja, de la que es su capital, cuenta con 34 673 habitantes (INE 2019)."],
    itext: ["Villajoiosa (in Valencian and co-officially La Vila Joiosa), is a municipality of the Valencian Community, Spain. Belonging to the province of Alicante and located on the Costa Blanca, in the Marina Baja region, of which it is its capital, it has 34 673 inhabitants (INE 2019)."],
    
    h: 24,
    v: 0
  },

  {
    id: 100,
    name: "Contact"
  }
];

